import { ApiClientBase } from "./ApiClientBase";
import { MsalOptions } from "./security";

class AccountService extends ApiClientBase {
    constructor() {
        super("/api/Account/");
    }

    public ConfirmDPAInstance(id: number) {
        return this.post<void, void>(`ConfirmDPAInstance/${id}`);
    }

    public Logout() {
        return this.request({ url: this.buildUrl("Logout"), method: "POST" }, true);
    }

    public MSALOptions(): Promise<MsalOptions> {
        return this.get(`MSALOptions`);
    }
}

export const accountService = new AccountService();
